import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propList: [],
}

const curatorExclusivePropsSlicer = createSlice({
  name: "curatorExclusiveProps",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setPropList: (state, { payload }) => {
      state.propList = payload;
    }
  },
});

export const {
  setPropList,
} = curatorExclusivePropsSlicer.actions;
export const curatorExclusivePropsActions = curatorExclusivePropsSlicer.actions;

export const curatorExclusivePropsSelector = (state) => state.curatorExclusiveProps;
export const curatorExclusivePropsReducer = curatorExclusivePropsSlicer.reducer;
export default curatorExclusivePropsReducer;

export const selectPropList = (state) => state.curatorExclusiveProps.propList